import Vue from 'vue';
import BaseUI from 'base-ui';

import DDLogs from '@/DDLogs';
import Segment from '@/Segment';
import Sentry from '@/Sentry';
import Intercom from '@/Intercom';
import App from '@/App';
import router from '@/router';
import store from '@/store';
import config from '@/config';
import initLiveSession from '@/livesession';
import initInterceptors from '@/api/interceptors';
import CustomerPiiPlugin from './plugins/CustomerPii';
import '@/quasar';
import '@/style';
import '@/validations';
import '@/dayjs';
import '@/touch-events';
import '@lottiefiles/lottie-player';
import '@/slider';

const RELOAD_LOCAL_STORAGE_KEY = 'reload-riseup-s-';
const currentHash = '{{POST_BUILD_ENTERS_HASH_HERE}}';

config.fetch().then(async () => {
  Vue.config.productionTip = false;

  DDLogs.init();
  if (!_validateLatestVersion()) {
    return;
  }

  initLiveSession(config.get());
  Sentry.init();
  initInterceptors();
  Vue.use(Segment);
  Vue.use(CustomerPiiPlugin);
  Vue.use(Intercom);
  Vue.use(BaseUI);

  new Vue({
    router,
    store,
    render: h => h(App),
  }).$mount('#app');
});

function _validateLatestVersion() {
  DDLogs.log('checking latest app version');
  const latestDeployedHash = config.get().hash;
  const isLastestAppVersion = currentHash === latestDeployedHash;
  DDLogs.log(isLastestAppVersion ? 'Client has latest app version' : 'Client has an older version', { currentHash, latestDeployedHash });
  if (!isLastestAppVersion) {
    return _tryReloadApp();
  }

  return isLastestAppVersion;
}

function _tryReloadApp() {
  const localStorageKey = _getTriesRetryLocalStorageKey(currentHash);
  const clientAlreadyRetried = localStorage.getItem(localStorageKey);
  if (!clientAlreadyRetried) {
    DDLogs.log('Reloading App', { currentHash });
    localStorage.setItem(localStorageKey, 'true');
    window.location.reload();
    return false;
  }
  DDLogs.log('App was already reloaded once, not reloading again!', { currentHash });
  return true;
}

function _getTriesRetryLocalStorageKey(currentHash) {
  return `${RELOAD_LOCAL_STORAGE_KEY}-${currentHash}`;
}
